import detailDefault from '../../detailDefault';
export default class detailacm_license_model extends detailDefault {
    load(sAction, data) {
        // jmeno relate pole Model -> Select Model
        sAction.dataSet(data.prefix + '/fields/aon_list_of_models_acm_license_model_1_name/def/vname', 'LBL_SELECT_MODEL');

        if (!sAction.dataGet(data.prefix + '/fields/id/value')) {
            setTimeout(() => {
                const value = {
                    id: sAction.dataGet(data.prefix + '/fields/aon_list_of_models_acm_license_model_1_name/def/id_value'),
                    name: sAction.dataGet(data.prefix + '/fields/aon_list_of_models_acm_license_model_1_name/value'),
                };
                this.loadModelData(sAction, data.prefix, value);
            }, 0);
            setTimeout(() => {
                const value = {
                    id: sAction.dataGet(data.prefix + '/fields/if4if_licenses_acm_license_model_1_name/def/id_value'),
                    name: sAction.dataGet(data.prefix + '/fields/if4if_licenses_acm_license_model_1_name/value'),
                };
                this.loadLicenseData(sAction, data.prefix, value);
            }, 0);
        }
    }

    update(sAction, data) {
        switch (data.field) {
            case 'aon_list_of_models_acm_license_model_1aon_list_of_models_ida':
                sAction.dsClear();
                sAction.dsAdd('set', data.prefix + '/fields/name/value', data.value.name);
                sAction.dsAdd('set', data.prefix + '/changes/fields/name', data.value.name);
                sAction.dsProcess();

                this.loadModelData(sAction, data.prefix, data.value);
                break;

            case 'if4if_licenses_acm_license_model_1if4if_licenses_ida':
                this.loadLicenseData(sAction, data.prefix, data.value);
                break;
        }
    }

    loadModelData(sAction, prefix, value) {
        if (!value.id) {
            return;
        }
        sAction.dsClear();
        sAction.dsAdd('set', prefix + '/fields/name_model/value', value.name);
        sAction.dsAdd('set', prefix + '/changes/fields/name_model', value.name);
        sAction.dsProcess();

        const fields = {
            model_type: 'model_type',
            subperil: 'subperil',
            risk_data: 'risk_data',
            loss_table: 'loss_table',
            original_model_release: 'original_model_release',
            date_of_last_update: 'date_of_last_update',
            date_of_next_update: 'date_of_next_update',
            contact_person_business_development_id: 'contact_person_business_development_id',
            contact_person_business_development: 'contact_person_business_development',
            description_portal: 'description_portal',
            description: 'description_model',
            assigned_user_id: 'contact_person_rad_id',
            assigned_user_name: 'contact_person_rad',
            current_model_version: 'current_model_version',
            aer: 'aer',
            hazard_data: 'hazard_data',
            peril: 'peril',
            region: 'region',
            name: 'name_model',
            model_id: 'model_id',
            scenario: 'scenario',
            probabilistic: 'probabilistic',
        };

        const sendData = {
            module: 'aon_list_of_models',
            id: value.id,
            fields: Object.keys(fields),
            action: 'getBeanInfo',
        };

        sAction.load();
        sAction.rest.fetchData('customAction', 'POST', sendData).then((returnData) => {
            // console.log(returnData)

            sAction.dsClear();
            returnData.forEachObject((v, k) => {
                sAction.dsAdd('set', prefix + '/fields/' + fields[k] + '/value', v);
                sAction.dsAdd('set', prefix + '/changes/fields/' + fields[k] + '', v);
            });
            sAction.dsProcess();

            sAction.unLoad();
        }).catch((data) => {
            console.error(data);
            sAction.unLoad();
        });
    }

    loadLicenseData(sAction, prefix, value) {
        if (!value.id) {
            return;
        }

        const sendData = {
            module: 'IF4IF_Licenses',
            id: value.id,
            fields: [
                'accounts_if4if_licenses_1accounts_ida',
                'accounts_if4if_licenses_1_name',
                'license_startdate',
                'auto_renewal_end_date',
            ],
            action: 'getBeanInfo',
        };

        sAction.load();
        sAction.rest.fetchData('customAction', 'POST', sendData).then((returnData) => {
            // console.log(returnData)

            sAction.dsClear();
            sAction.dsAdd('set', prefix + '/fields/start_date/value', returnData.license_startdate);
            sAction.dsAdd('set', prefix + '/changes/fields/start_date', returnData.license_startdate);
            sAction.dsAdd('set', prefix + '/fields/end_date/value', returnData.auto_renewal_end_date);
            sAction.dsAdd('set', prefix + '/changes/fields/end_date', returnData.auto_renewal_end_date);
            sAction.dsProcess();

            const fieldData = {
                way: prefix + '/fields/accounts_acm_license_model_1_name',
                name: 'accounts_acm_license_model_1accounts_ida',
                fieldName: 'accounts_acm_license_model_1_name',
                type: 'relate',
                value: {
                    id: returnData.accounts_if4if_licenses_1accounts_ida,
                    name: returnData.accounts_if4if_licenses_1_name,
                },
            };

            sAction.saveField(fieldData, true);

            sAction.unLoad();
        }).catch((data) => {
            console.error(data);
            sAction.unLoad();
        });
    }
}
